import React from 'react'
import {
  ControlsContainer,
  PlayPauseButton,
  RewindButton,
  Volume
} from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

export const Controls = ({
  disabled = false,
  loading = false,
  extraControlsList = ['rewind', 'volume']
}) => {
  const { play, pause, playing: isPlaying, onRewind } = useMotePlayer()
  const disableControls = disabled || loading

  return (
    <ControlsContainer>
      {extraControlsList.includes('rewind') && (
        <RewindButton
          size={25}
          disabled={!isPlaying || disableControls}
          aria-label='Rewind (press j)'
          data-testid='rewind-button'
          onClick={
            isPlaying
              ? e => {
                  e.stopPropagation()
                  onRewind()
                }
              : null
          }
        />
      )}

      <PlayPauseButton
        size={36}
        disabled={disableControls}
        data-testid={isPlaying ? 'pause-button' : 'play-button'}
        aria-label={`${isPlaying ? 'Pause' : 'Play'} (press k)`}
        isPlaying={isPlaying}
        onClick={e => {
          e.stopPropagation()
          isPlaying ? pause() : play()
        }}
      />

      {extraControlsList.includes('volume') && (
        <Volume disabled={disableControls} />
      )}
    </ControlsContainer>
  )
}
